import FeatureLayerProperties = __esri.FeatureLayerProperties

export const layerProps: FeatureLayerProperties = {
	id: 'WaterWorkZones',
	minScale: 50000
}
